module.exports = __webpack_public_path__ + "static/media/ua.cf1a4bc6.svg";